module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/bg_equipment-ee8e79c847bf4993170435790e45f420.png";